export enum FondsAnlagestrategie {
  GEMANAGTES_PORTFOLIO = 'LV1871Portfolioloesung',
  INDIVIDUELLES_PORTFOLIO = 'IndividuellesPortfolio',
}
